import { Box, BoxProps } from "@chakra-ui/react";

export function UserIcon({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.28125"
          y="0.28125"
          width="35.4375"
          height="35.4375"
          rx="17.7188"
          fill="#C2D9EF"
          fill-opacity="0.32"
        />
        <rect
          x="0.28125"
          y="0.28125"
          width="35.4375"
          height="35.4375"
          rx="17.7188"
          stroke="#E4EBF0"
          stroke-width="0.5625"
        />
        <path
          d="M17.9971 19.9023C22.4322 19.9026 26.0332 23.5042 26.0332 27.9395C26.0331 28.338 25.7101 28.661 25.3115 28.6611C24.9128 28.6611 24.589 28.3381 24.5889 27.9395C24.5889 24.3007 21.6349 21.3469 17.9971 21.3467C14.3581 21.3467 11.4043 24.3014 11.4043 27.9395C11.4042 28.3381 11.0803 28.6611 10.6816 28.6611C10.2831 28.661 9.96007 28.338 9.95996 27.9395C9.95996 23.5041 13.5617 19.9023 17.9971 19.9023ZM17.9971 7.33984C21.0004 7.34008 23.4375 9.77881 23.4375 12.7812C23.4373 15.7845 20.9993 18.2214 17.9971 18.2217C14.9937 18.2217 12.5559 15.7837 12.5557 12.7812C12.5557 9.77773 14.9945 7.33984 17.9971 7.33984ZM17.9971 8.78418C15.791 8.78418 14 10.5752 14 12.7812C14.0002 14.9872 15.7912 16.7783 17.9971 16.7783C20.2028 16.7781 21.9929 14.987 21.9932 12.7812C21.9932 10.5753 20.2029 8.78442 17.9971 8.78418Z"
          fill="#498ECF"
          stroke="#498ECF"
          stroke-width="0.5"
        />
      </svg>
    </Box>
  );
}
